import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Landmark } from "lucide-react";
import { Shell } from "./Shell";
import { client } from "@/lib/api";

export default function BankTransfer() {
  const [bank, setBank] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    client.get("/bank-transfer").then(r => { if (active) setBank(r.data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, []);
  return <Shell><section className="legal" data-testid="bank-transfer-page">
    <div className="eyebrow">ÖDEME YÖNTEMİ</div>
    <h1>Havale / EFT ile ödeme</h1>
    {!bank && !error && <p>Hesap bilgileri yükleniyor…</p>}
    {(error || bank?.enabled === false) && <div className="notice" data-testid="bank-transfer-unavailable">
      {error ? "Hesap bilgileri şu anda alınamıyor. Lütfen daha sonra tekrar deneyin veya bize ulaşın." : "Havale / EFT seçeneği şu anda kullanıma kapalıdır."}
    </div>}
    {bank?.enabled && <>
      <div className="legal-block" data-testid="bank-transfer-account"><h2><Landmark size={18}/> Şirket banka hesabı</h2>
        <p><b>Banka:</b> {bank.bank_name}</p>
        <p><b>Hesap sahibi:</b> <span data-testid="public-bank-holder">{bank.account_holder}</span></p>
        <p><b>IBAN:</b> <strong data-testid="public-bank-iban" style={{overflowWrap:"anywhere"}}>{bank.iban}</strong></p>
      </div>
      <div className="legal-block"><h2>Nasıl ödeme yaparım?</h2><ol>
        <li>Önce paket seçip siparişinizi oluşturun.</li>
        <li>Siparişinizde gösterilen kargo dahil genel toplamı bu hesaba gönderin.</li>
        <li>Açıklamaya “Sipariş kodu – Ad Soyad” yazın. Sipariş sonrasında açıklama sizin bilgilerinizle hazır gösterilir.</li>
      </ol><p>{bank.instructions}</p>
      <p>Dekont tek başına ödeme onayı değildir. Sipariş takibinden ödeme durumunuzu görebilirsiniz.</p></div>
    </>}
    <div className="actions"><Link className="btn primary" to="/paketler">Paketleri incele</Link>
      <Link className="btn ghost" to="/takip">Siparişimi takip et</Link></div>
  </section></Shell>;
}
